import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import API from 'utils/api/api'
import APPURL from 'utils/app/urls'
import RegionTools from 'utils/regions/regionTools'
import DateTools from 'utils/dates/dateTools'

import RegionChangerController from 'modules/Controllers/RegionChanger/RegionChangerController'
import HomeMap from 'modules/Charts/Map/HomeMap'

import Loading from 'components/Loading'
import Error from 'components/Error'

class HomeContent extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    this.props.setSelectedRegionId(null)
    this.loadData()
  }

  loadData() {
    const p1 = API.getRegions().then(regions => RegionTools.getDataFromRegions(regions))

    const p2 = API.getCountries().then(countries => RegionTools.getDataFromCountries(countries))

    const p3 = API.getIndicatorsStatus().then(indicatorsStatus => indicatorsStatus.last_checked_on)

    Promise.all([p1, p2, p3])
      .then(values => {
        this.props.setRegionsData(values[0])
        this.props.setCountriesData(values[1])
        this.props.setIndicatorsLastUpdated(values[2])
        return values[2]
      })
      .then(lastUpdated => {
        this.setState({ loading: false, lastUpdated: lastUpdated })
      })
      .catch(reason => {
        this.setState({ error: true, loading: false })
      })
  }

  renderIfAllOK() {
    if (this.state.error) {
      return <Error />
    } else if (this.state.loading) {
      return <Loading />
    } else {
      const path = this.props.history.location.pathname
      const methodologyLink = APPURL.getMethodologyLink(path);
      const reportPanelLink = APPURL.getReportPanelLink(path, "ES21");
      // const benchmarkingLink = 'http://s3platform.jrc.ec.europa.eu/regional-benchmarking'
      const lastUpdated = DateTools.formatDateForContentHeader(this.state.lastUpdated)
      return (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12">
                <h1 className="ork-u-mb">
                  {this.formatMessage(messages.title)} <small>{this.formatMessage(messages.updated, { lastUpdated })}</small>
                </h1>
              </div>
            </div>
          </div>
          <div className="container-fluid ork-gray-box">
            <div className="row">
              <div className="col-md-8 col-md-push-4">
                <div className="ork-home-map-wrapper">
                  <div className="row ork-home-map-select-wrapper">
                    <div className="col-md-6">
                      <RegionChangerController />
                    </div>
                  </div>
                  <HomeMap />
                </div>
              </div>
              <div className="col-md-4 col-md-pull-8">
                <div className="ork-home-map-aside">
                  <p className="ork-u-mb-2" dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.welcome) }} />
                  <p className="ork-u-mb-2" dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.secondParagraph) }} />
                  <p>
                    <a href="" role="button" className="btn btn-primary hidden">
                      <i className="fal fa-video fa-lg" />
											&nbsp;<span className="ork-u-ml-half">{this.formatMessage(messages.videoButton)}</span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="row ork-home-panels">
              {/* <div className="col-md-4">
                <div className="panel">
                  <div className="panel-body">
                    <h2 className="h3 ork-u-mt-0 ork-u-text-blue">{this.formatMessage(messages.benchmarking)}</h2>
                    <div className="ork-u-mt">
                      <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.benchmarkingParagraph, { benchmarkingLink }) }} />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-md-12">
                <div className="panel">
                  <div className="panel-body alert-new">
                    <h2 className="h3 ork-u-mt-0">{this.formatMessage(messages.reportPanelTitle)}</h2>
                    <div className="ork-u-mt">
                      <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.reportPanelParagraph, { reportPanelLink, methodologyLink }) }} />
                    </div>
                  </div>
                </div>
              </div>
              
              </div>
              <div className="row ork-home-panels">
              
              <div className="col-md-6">
                <div className="panel">
                  <div className="panel-body">
                    <h2 className="h3 ork-u-mt-0 ork-u-text-green">{this.formatMessage(messages.lastData)}</h2>
                    <div className="ork-u-mt">
                      <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.lastDataParagraph) }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="panel">
                  <div className="panel-body">
                    <h2 className="h3 ork-u-mt-0 ork-u-text-pink">{this.formatMessage(messages.competitivenessFrame)}</h2>
                    <div className="ork-u-mt">
                      <p dangerouslySetInnerHTML={{ __html: this.formatMessage(messages.competitivenessFrameParagraph, { methodologyLink }) }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}

export default injectIntl(HomeContent)



// WEBPACK FOOTER //
// ./src/modules/HomeContent/HomeContent.jsx